import React from 'react';
import { useTranslation } from 'react-i18next';

export const SALES_STATUSES = ['active', 'draft', 'rd'];

export function countByStatus(products) {
    const counts = { all: products.length, active: 0, draft: 0, rd: 0, delivery: 0 };
    products.forEach((p) => {
        if (p.is_delivery) counts.delivery += 1;
        if (counts[p.sales_status] !== undefined) counts[p.sales_status] += 1;
    });
    return counts;
}

export function matchesStatusFilter(p, filter) {
    if (filter === 'all') return true;
    if (filter === 'delivery') return Boolean(p.is_delivery);
    return p.sales_status === filter;
}

export function ProductStatusBadge({ status, title }) {
    const { t } = useTranslation();
    if (!SALES_STATUSES.includes(status)) return null;
    return <span title={title} className={`badge ms-2 product-status-badge product-status-badge--${status}`}>{t(`products.status.${status}`)}</span>;
}

export function ProductStatusChips({ value, onChange, counts, includeDelivery = false }) {
    const { t } = useTranslation();
    const keys = includeDelivery ? ['all', 'active', 'draft', 'rd', 'delivery'] : ['all', 'active', 'draft', 'rd'];
    return (
        <div className="product-status-chips" role="group" aria-label={t('products.statusFilterAria')}>
            {keys.map((key) => (
                <button
                    key={key}
                    type="button"
                    className={`product-status-chip${value === key ? ' is-active' : ''}`}
                    aria-pressed={value === key}
                    onClick={() => onChange(key)}
                >
                    {key === 'all' ? t('products.filterAll') : key === 'delivery' ? t('products.filterDelivery') : t(`products.status.${key}`)}
                    <span className="product-status-chip__count">{counts[key]}</span>
                </button>
            ))}
        </div>
    );
}
